import { MediaDisplayType } from '@calm/evexia-web-sdk';
import { CardVariant } from '@rhg/components/card/types';
import { SkeletonCardVariant } from '@rhg/components/ui/skeletons';
import { routes } from '../routes';

interface GetViewAllHrefFromPackClassProps {
    displayType?: MediaDisplayType;
    packClass?: string;
    isViewAll?: boolean;
}

const displayTypeToCardVariantMap = {
    'calm-health-goals-row-cards': 'carousel',
    'calm-health-clinical-carousel': 'carousel',
    'banner-carousel': 'carousel',
    'calm-health-snappy-quick-nav': 'carousel',
    carousel: 'carouselSquare',
    'calm-health-dailies-grid': 'carousel',
};

export function getCardVariantFromDisplayType(
    displayType?: MediaDisplayType
): CardVariant {
    if (
        !displayType ||
        !Object.prototype.hasOwnProperty.call(
            displayTypeToCardVariantMap,
            displayType
        )
    ) {
        return 'carouselSquare';
    }
    // the .hasOwnProperty() check above should have prevented any non-matching displayType from reaching this point but TS is claiming there needs to be an explicit type cast here.
    return displayTypeToCardVariantMap[
        displayType as keyof typeof displayTypeToCardVariantMap
    ] as CardVariant;
}

const displayTypeToSkeletonTypeMap = {
    'calm-health-goals-row-cards': 'discoverLargeButton',
    'calm-health-clinical-carousel': 'clinical',
    'banner-carousel': 'daily',
    'calm-health-snappy-quick-nav': 'quickNav',
    carousel: 'daily',
    'calm-health-dailies-grid': 'daily',
};

export function getSkeletonTypeFromDisplayType(
    displayType?: MediaDisplayType
): SkeletonCardVariant {
    if (
        !displayType ||
        !Object.prototype.hasOwnProperty.call(
            displayTypeToSkeletonTypeMap,
            displayType
        )
    ) {
        return 'daily';
    }

    // Same as above, TS is claiming there needs to be an explicit type cast here.
    return displayTypeToSkeletonTypeMap[
        displayType as keyof typeof displayTypeToSkeletonTypeMap
    ] as SkeletonCardVariant;
}

export function getViewAllHrefFromPackClass({
    displayType,
    packClass,
    isViewAll = false,
}: GetViewAllHrefFromPackClassProps): string {
    switch (displayType) {
        case 'calm-health-clinical-carousel':
            return routes.discoverClinical;
        case 'calm-health-dailies-grid':
            return routes.discoverDailies();

        default:
            return packClass
                ? routes.discoverPack(packClass, isViewAll)
                : routes.discover;
    }
}
